import { memo } from "react";
import { equals } from "ramda";
import { Remove, DrillButton, Value, Td } from "./graphAxisTable.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function Row(props) {
  var entry = props.entry,
    remove = props.remove,
    drilldown = props.drilldown,
    drilldownLabel = props.drilldownLabel,
    disableInteraction = props.disableInteraction;
  var valuesMarkup = entry.data.map(function (x, idx) {
    var title = x.helpText || x.partition;
    var value = x.dependent || x.label || "-";
    return /*#__PURE__*/_jsx(Value, {
      title: title,
      values: entry.data.length,
      children: value
    }, idx);
  });
  var _drilldownLabel = drilldownLabel ? "".concat(drilldownLabel).concat(entry.name) : undefined;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Td, {
      "aria-colindex": "1",
      children: /*#__PURE__*/_jsx(Remove, {
        "aria-label": "Ta bort ".concat(entry.name),
        className: "remove-pre-png",
        color: entry.color,
        disableInteraction: disableInteraction,
        disabled: disableInteraction,
        onClick: function onClick() {
          return remove(entry.id);
        }
      })
    }), /*#__PURE__*/_jsx(Td, {
      "aria-colindex": "2",
      title: entry.name,
      children: /*#__PURE__*/_jsx(DrillButton, {
        "aria-label": _drilldownLabel,
        disabled: disableInteraction || !entry.drillable,
        onClick: function onClick() {
          return drilldown(entry.id);
        },
        children: entry.name
      })
    }), /*#__PURE__*/_jsx(Td, {
      "aria-colindex": "3",
      children: /*#__PURE__*/_jsx("div", {
        children: valuesMarkup
      })
    })]
  });
}, function (prev, curr) {
  return equals(prev.entry, curr.entry) && equals(prev.disableInteraction, curr.disableInteraction);
});